import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: '',
    redirectTo: 'initial-setup',
    pathMatch: 'full',
  },

  {
    path: 'initial-setup',
    loadChildren: () =>
      import('./pages/initial-setup/initial-setup.module').then(
        (m) => m.InitialSetupPageModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'default-settings',
    loadChildren: () =>
      import('./pages/default-settings/default-settings.module').then(
        (m) => m.DefaultSettingsPageModule
      ),
  },
  {
    path: 'omni-setup',
    loadChildren: () =>
      import('./pages/omni-setup/omni-setup.module').then(
        (m) => m.OmniSetupPageModule
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./pages/settings/settings.module').then(
        (m) => m.SettingsPageModule
      ),
  },
  {
    path: 'call-dial',
    loadChildren: () =>
      import('./pages/call-dial/call-dial.module').then(
        (m) => m.CallDialPageModule
      ),
  },
  {
    path: 'edit-profile',
    loadChildren: () =>
      import('./pages/edit-profile/edit-profile.module').then(
        (m) => m.EditProfilePageModule
      ),
  },
  {
    path: 'manage-groups',
    loadChildren: () =>
      import('./pages/manage-groups/manage-groups.module').then(
        (m) => m.ManageGroupsPageModule
      ),
  },
  {
    path: 'speed-dial',
    loadChildren: () =>
      import('./pages/speed-dial/speed-dial.module').then(
        (m) => m.SpeedDialPageModule
      ),
  },
  {
    path: 'bypass',
    loadChildren: () =>
      import('./pages/bypass/bypass.module').then((m) => m.BypassPageModule),
  },
  {
    path: 'contacts',
    loadChildren: () =>
      import('./pages/contacts/contacts.module').then(
        (m) => m.ContactsPageModule
      ),
  },
  {
    path: 'favourites',
    loadChildren: () =>
      import('./pages/contacts/contacts.module').then(
        (m) => m.ContactsPageModule
      ),
  },
  {
    path: 'keypad',
    loadChildren: () =>
      import('./pages/keypad/keypad.module').then((m) => m.KeypadPageModule),
  },
  {
    path: 'groups',
    loadChildren: () =>
      import('./pages/groups/groups.module').then((m) => m.GroupsPageModule),
  },
  {
    path: 'view-contact',
    loadChildren: () =>
      import('./pages/view-contact/view-contact.module').then(
        (m) => m.ViewContactPageModule
      ),
  },

  {
    path: 'conxhub-settings',
    loadChildren: () =>
      import('./pages/conxhub-settings/conxhub-settings.module').then(
        (m) => m.ConxhubSettingsPageModule
      ),
  },
  {
    path: 'favorite-contacts',
    loadChildren: () =>
      import('./pages/favorite-contacts/favorite-contacts.module').then(
        (m) => m.FavoriteContactsPageModule
      ),
  },
  {
    path: 'home-contacts',
    loadChildren: () =>
      import('./pages/home-contacts/home-contacts.module').then(
        (m) => m.HomeContactsPageModule
      ),
  },
  {
    path: 'active-q',
    loadChildren: () =>
      import('./pages/active-q/active-q.module').then(
        (m) => m.ActiveQPageModule
      ),
  },
  {
    path: 'queued-call',
    loadChildren: () =>
      import('./pages/queued-call/queued-call.module').then(
        (m) => m.QueuedCallPageModule
      ),
  },
  {
    path: 'recents',
    loadChildren: () =>
      import('./pages/recents/recents.module').then((m) => m.RecentsPageModule),
  },
  {
    path: 'detail',
    loadChildren: () =>
      import('./pages/detail/detail.module').then((m) => m.DetailPageModule),
  },
  {
    path: 'favorites',
    loadChildren: () =>
      import('./pages/favorites/favorites.module').then(
        (m) => m.FavoritesPageModule
      ),
  },
  {
    path: 'send-message',
    loadChildren: () =>
      import('./pages/send-message/send-message.module').then(
        (m) => m.SendMessagePageModule
      ),
  },
  {
    path: 'add-profile',
    loadChildren: () =>
      import('./pages/add-profile/add-profile.module').then(
        (m) => m.AddProfilePageModule
      ),
  },
  {
    path: 'verify-your-number',
    loadChildren: () =>
      import('./pages/verify-your-number/verify-your-number.module').then(
        (m) => m.VerifyYourNumberPageModule
      ),
  },

  {
    path: 'search-contact',
    loadChildren: () =>
      import('./pages/search-contact/search-contact.module').then(
        (m) => m.SearchContactPageModule
      ),
  },
  {
    path: 'news',
    loadChildren: () =>
      import('./pages/news/news.module').then((m) => m.NewsPageModule),
  },
  {
    path: 'call-voip',
    loadChildren: () =>
      import('./pages/call-voip/call-voip.module').then(
        (m) => m.CallVoipPageModule
      ),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
